module.exports = __webpack_public_path__ + "assets/certificate_pdf/DUKE_AUTOCAD.5a909a7e.pdf";